import { FormLabel, Grid } from '@material-ui/core'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  TextFontRes: {
    padding: theme.spacing(3.5),
    fontWeight: theme.typography.fontWeightMedium,
  },
  subheadColor: {
    color: '#1b1b25',
  },
  previewMargin: {
    marginTop: theme.spacing(11),
    '&:nth-child(3), &:nth-child(4)': {
      marginTop: theme.spacing(3),
    },
  },
}))

const PreviewDisplay = ({
  labelId,
  defaultMessage,
  sequence,
  sequenceValidation,
  fiveModeValue,
  threeModeValue,
  overhang,
  formatOverhangSequence,
  modificationNone,
  senseValidationError = false,
}) => {
  const classes = useStyles()
  return (
    <>
      <Grid item xs={3} className={classes.previewMargin}>
        <FormLabel className={clsx(classes.TextFontRes, classes.subheadColor)}>
          <FormattedMessage id={labelId} defaultMessage={defaultMessage} />:
        </FormLabel>
      </Grid>
      <Grid item xs={8} className={classes.previewMargin}>
        {sequence.length !== 0 &&
        sequenceValidation.length === 0 &&
        !senseValidationError ? (
          <>
            {fiveModeValue !== modificationNone.none ? fiveModeValue : ''}
            {sequence}
            {formatOverhangSequence(overhang)}
            {threeModeValue !== modificationNone.none ? threeModeValue : ''}
          </>
        ) : sequence.length === 0 ? (
          <FormattedMessage
            id="EMPTY_SEQUENCE_PREVIEW_TEXT"
            defaultMessage="Start typing sequence above to see the preview."
          />
        ) : (
          '_ _'
        )}
      </Grid>
    </>
  )
}
export default PreviewDisplay
